


 <div class="row">

  <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <div class="btn-toolbar mb-2 mb-md-0">    <!-- *ngIf="canAccess(['edit_users'])"-->
      <!-- <a routerLink="/plants/create" class="btn btn-sm btn-outline-secondary">Agregar</a> -->
      <button (click)="mostrarBootstrapModal(null,'save')" class="btn btn-sm btn-outline-secondary">Agregar</button>
    </div>
  </div>



  <div class="col-8 input-group">

    

    <select class="custom-select" id="sucursal"  [(ngModel)]="sucursal">
                      <option disabled value="">Seleccione...</option>
                      <option *ngFor="let plant of plants" [value]="plant.id_planta">{{plant.nom_planta}}</option>
     </select>
       <input type="text" id="nombre_ceco" class="form-control"  [placeholder]="'Ingrese el Nombre'"  [(ngModel)]="nombre_ceco" required>
    <span class="input-group-btn">

       <button class="btn btn-primary rounded-0" (click)="refresh(1,nombre_ceco,sucursal)"    >Buscar</button>
    </span>
  </div>
</div>








<div class="table-responsive">
  <table class="table ">
    <thead>
      <tr>
        <th>#</th>
        <th>Nombre</th>
        <th>Sucursal</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let ceco of centroCosto">
        <td>{{ceco.orden_ceco}}</td>
        <td>{{ceco.nombre_ceco}}</td>
        <td>{{ceco.plantas.nom_planta}}</td>
        <td>
          <div class="btn-group mr-2" >
            <a href="javascript:void(0)" (click)="mostrarBootstrapModal(ceco.orden_ceco,'edit')" class="btn  btn-outline-secondary mr-2"><i class="fa fa-pencil "></i></a>
            <a href="javascript:void(0)" (click)="delete(ceco.orden_ceco)" class="btn  btn-outline-danger"><i class="fa fa-trash-o "></i></a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<app-paginator
  [lastPage]="lastPage"
  (pageChanged)="refresh($event)"
></app-paginator>

